import React, { useEffect } from "react";

const CookieYes = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.id = "cookieyes"
        script.type = "text/javascript"
        script.src = "https://cdn-cookieyes.com/client_data/27d215a4ef68cea85a2d193c5f893014/script.js"

        document.head.appendChild(script);

    }, [])

    return (
        <></>
    )
}

export default CookieYes
